import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';
import { toLocalISOString } from 'vscode/vscode/vs/base/common/date';
import { joinPath } from 'vscode/vscode/vs/base/common/resources';
import { FileOutputChannelModel, DelegatedOutputChannelModel } from './outputChannelModel.js';

let OutputChannelModelService = class OutputChannelModelService {
    constructor(fileService, instantiationService, environmentService) {
        this.fileService = fileService;
        this.instantiationService = instantiationService;
        this._outputDir = null;
        this.outputLocation = joinPath(environmentService.windowLogsPath, `output_${toLocalISOString(( new Date())).replace(/-|:|\.\d+Z$/g, '')}`);
    }
    createOutputChannelModel(id, modelUri, language, file) {
        return file ? this.instantiationService.createInstance(FileOutputChannelModel, modelUri, language, file) : this.instantiationService.createInstance(DelegatedOutputChannelModel, id, modelUri, language, this.outputDir);
    }
    get outputDir() {
        if (!this._outputDir) {
            this._outputDir = this.fileService.createFolder(this.outputLocation).then(() => this.outputLocation);
        }
        return this._outputDir;
    }
};
OutputChannelModelService = ( __decorate([
    ( __param(0, IFileService)),
    ( __param(1, IInstantiationService)),
    ( __param(2, IWorkbenchEnvironmentService))
], OutputChannelModelService));

export { OutputChannelModelService };
